import script from "./GlobalOps.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalOps.vue?vue&type=script&setup=true&lang=js"

import "./GlobalOps.vue?vue&type=style&index=0&id=1d843f79&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d843f79"]])

export default __exports__